import styled from '@emotion/styled';

export const SignupCheckboxLabel = styled.label`
	position: relative;
	display: inline-flex;
	align-items: center;
	gap: ${({ theme }) => theme.scale.spaceSm};
	font-size: ${({ theme }) => theme.fontSize.sizeMd};
	font-weight: ${({ theme }) => theme.fontWeight.weightSemi};
	line-height: 1.4;
	color: ${({ theme }) => theme.ui.text.primary};
	cursor: pointer;

	input[type='checkbox'] {
		appearance: none;
		width: 2rem;
		height: 2rem;
		flex-shrink: 0;
		border: 1.5px solid ${({ theme }) => theme.ui.border.strong};
		border-radius: 0.6rem;
		background-color: ${({ theme }) => theme.ui.surface.page};
		background-repeat: no-repeat;
		background-position: center;
		background-size: 1.1rem 0.9rem;
		cursor: pointer;
		transition:
			border-color ${({ theme }) => theme.effects.transitionFast},
			background-color ${({ theme }) => theme.effects.transitionFast},
			box-shadow ${({ theme }) => theme.effects.transitionFast};

		&:checked {
			border-color: ${({ theme }) => theme.ui.interactive.primary};
			background-color: ${({ theme }) => theme.ui.interactive.primary};
			background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 10' fill='none'%3E%3Cpath d='M1 5.5 4.5 9 11 1' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
		}

		&:focus-visible {
			outline: none;
			box-shadow: 0 0 0 3px ${({ theme }) => theme.ui.interactive.focusRing};
		}
	}
`;

export const StepContent = styled.section`
	width: 100%;
	padding: ${({ theme }) => theme.scale.space2xl};
	border: 1px solid ${({ theme }) => theme.ui.border.default};
	border-radius: ${({ theme }) => theme.effects.radiusLg};
	background: ${({ theme }) => theme.ui.surface.page};
	box-shadow: ${({ theme }) => theme.effects.shadowSm};

	@media screen and (max-width: 900px) {
		padding: ${({ theme }) => theme.scale.spaceLg};
	}
`;

export const FormActions = styled.div`
	display: flex;
	width: 100%;
	margin-top: ${({ theme }) => theme.scale.space2xl};
	padding-top: ${({ theme }) => theme.scale.spaceLg};
	border-top: 1px solid ${({ theme }) => theme.ui.border.default};

	& > button {
		width: 100%;
	}
`;

export const RequiredNotice = styled.p`
	margin: 0 0 ${({ theme }) => theme.scale.spaceMd};
	font-size: ${({ theme }) => theme.fontSize.sizeSm};
	color: ${({ theme }) => theme.colors.red600};
	line-height: 1.4;
`;
